export default { 
  name : 'product.event.location',
  objectType : 'product.event',
  valueType : 'string@',
  displayName : 'Location',
  get : ( obj, cxt ) => {
    return {
      pogId : obj?.data?.pogId,
      aisleId : obj?.data?.aisleId,
      segmentId : obj?.data?.segmentId,
      level : obj?.data?.data?.detection?.level
    }
  }
}
